import { Controller } from "@hotwired/stimulus"
import Bugsnag from "../bugsnag"

export default class extends Controller {
  static values = { id: String }

  declare idValue: string

  open() {
    const modal = document.getElementById(this.idValue)
    if (!modal) {
      Bugsnag.notify(new Error(`Modal not found: ${this.idValue}`))
      return
    }

    globalThis.bootstrap.Modal.getOrCreateInstance(modal).show()
  }
}
